module.exports = __webpack_public_path__ + "img/schnittkante_hellgrau_farbnummer705.8013c582.jpg";